<template>
  <v-app>
    <template v-if="!$route.meta.allowAnonymous">
      <Global />
      <Navigation />
      <Toolbar />
      <v-main>
        <v-container fluid>
          <div class="d-flex justify-center">
            <AdTemplate :adLocation="1" max-width="900px"></AdTemplate>
          </div>
          <Breadcrumbs />
          <router-view></router-view>
        </v-container>
        <v-fab-transition>
          <v-btn
            v-scroll="onScroll"
            v-show="fab"
            @click="toTop"
            absolute
            fab
            fixed
            right
            bottom
            class="mb-10"
            color="primary"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
        <Footer />
      </v-main>
    </template>
    <template v-if="$route.meta.allowAnonymous">
      
      <Login />
    </template>
    <Snackbar />
    <ExpiringNotification></ExpiringNotification>
  </v-app>
</template>

<script>
import stringValuesData from "../src/assets/string_values.json"
export default {
  name: "App",
  data: () => ({
    fab: false,
  }),
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  created(){
    this.$store
        .dispatch('COMMIT_STRING_VALUES', stringValuesData)
        .then(() => {})
        .catch((error) => {
          window.console.log(error)
        })
  }
};
</script>
<style scoped></style>
